import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "authentiBox"
}
const _hoisted_2 = { class: "authentiCon" }
const _hoisted_3 = { class: "imgBox" }
const _hoisted_4 = {
  key: 0,
  class: "p"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "p"
}
const _hoisted_7 = {
  key: 3,
  class: "reject"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 1,
  class: "VerificaBox"
}
const _hoisted_10 = { class: "promiseBox" }
const _hoisted_11 = { class: "VerificSwitch" }
const _hoisted_12 = { class: "Switch_mode" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "SwitchContent" }
const _hoisted_15 = { class: "Highlight" }
const _hoisted_16 = { style: {"width":"60%","text-align":"center"} }
const _hoisted_17 = { class: "Switch_name" }
const _hoisted_18 = { style: {"width":"10%"} }
const _hoisted_19 = { class: "modeType" }
const _hoisted_20 = {
  key: 0,
  class: "modeOne"
}
const _hoisted_21 = { class: "enterprisecon" }
const _hoisted_22 = { class: "enterpriseUpload" }
const _hoisted_23 = { class: "modeCon" }
const _hoisted_24 = { class: "info_name" }
const _hoisted_25 = {
  key: 0,
  class: "form_item"
}
const _hoisted_26 = { class: "selectBox" }
const _hoisted_27 = { class: "bottomBox" }
const _hoisted_28 = { class: "PrivacyBox" }
const _hoisted_29 = {
  key: 1,
  class: "modeOne"
}
const _hoisted_30 = { class: "enterprisecon" }
const _hoisted_31 = { class: "personalUpload" }
const _hoisted_32 = { class: "modeCon" }
const _hoisted_33 = { class: "info_name" }
const _hoisted_34 = {
  key: 0,
  class: "form_item"
}
const _hoisted_35 = { class: "selectBox" }
const _hoisted_36 = { class: "bottomBox" }
const _hoisted_37 = { class: "PrivacyBox" }

import Ccertificates from '../components/Ccertificates.vue';
import { message, Space, Select } from 'ant-design-vue';
import { cityData, provinceData } from '../views/account/personalSet/Certification/dataJson';
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
import { ref, shallowRef, reactive } from 'vue';
import { getToken } from '@/plugins/cookie';
import http from '@/api/playback';
import httpcode from '@/api/home';
const TIME_COUNT = 60;
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: any;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Verification',
  setup(__props) {

const token = getToken();
const aSpace = Space;
const aSelect = Select;
const province = ref(provinceData[0]);
const cities = ref(cityData[province.value]);
const secondCity = ref(cityData[province.value][0]);
const authenStatus = ref<boolean>(false);
const Privacychecked = ref<boolean>(false);
const modeId = ref(2);
const checkedOne = ref<boolean>(true);
const checkedTwo = ref<boolean>(false);
const getMode = (id: number) => {
  clear();
  modeId.value = id;
  if (modeId.value == 2) {
    modeList.value[0].checked = true;
    modeList.value[1].checked = false;
  } else {
    modeList.value[0].checked = false;
    modeList.value[1].checked = true;
  }
};
// 下拉
const selectChange = () => {
  cities.value = cityData[province.value];
  secondCity.value = cityData[province.value][0];
};
//企业认证
const selectChangeTwo = () => {
  VerificList.value[5].model = secondCity.value;
};
const selectChangeOne = () => {
  personalList.value[4].model = secondCity.value;
};
const clear = () => {
  province.value = provinceData[0];
  cities.value = cityData[province.value];
  secondCity.value = cityData[province.value][0];
};
// 直播模式
const modeList = shallowRef([
  {
    id: 2,
    name: '企业认证',
    content: '免费直播10场，提供专业技术指导',
    icon: 'companyHigh',
    checked: checkedOne.value,
  },
  {
    id: 1,
    name: '个人认证',
    content: '免费直播5场',
    icon: 'personalHighlight',
    checked: checkedTwo.value,
  },
]);
//企业认证的信息
const VerificList = ref([
  {
    name: '企业名称 :',
    placeholder: '请输入企业名称',
    model: '',
    length: 500,
    id: 0,
  },
  {
    name: '统一信用代码 :',
    placeholder: '请输入统一信用代码',
    model: '',
    length: 18,
    id: 1,
  },
  {
    name: '经营地址 :',
    placeholder: '请输入经营地址',
    model: '',
    length: 500,
    id: 2,
  },
  {
    name: '联系人 :',
    placeholder: '请输入联系人',
    model: '',
    length: 500,
    id: 3,
  },
  {
    name: '手机号码 :',
    placeholder: '请输入手机号码',
    model: '',
    length: 11,
    id: 4,
  },
]);
const showCodeBtn = ref<boolean>(false);
const showCodeBtntwo = ref<boolean>(false);
const mobilecode = ref<string>();
const changeMobile = (item: any) => {
  if (!item) {
    return;
  }
  showCodeBtntwo.value = true;
};
const changeMobileTwo = (item: any) => {
  if (!item) {
    return;
  }
  showCodeBtn.value = true;
};
let isShowcode = ref(true);
let timer: any = ref(0);
let count = ref(TIME_COUNT);
const getCode = (modeId: number) => {
  if (modeId == 2) {
    if (!timer.value) {
      count.value = TIME_COUNT;
      isShowcode.value = false;
      timer.value = setInterval(() => {
        if (count.value > 0 && count.value <= TIME_COUNT) {
          count.value--;
        } else {
          isShowcode.value = true;
          clearInterval(timer.value);
          timer.value = 0;
        }
      }, 1000);
    }
    // 获取验证码
    httpcode.sendCaptcha({ mobile: VerificList.value[4].model, type: 0 });
  }
  if (modeId == 1) {
    if (!timer.value) {
      count.value = TIME_COUNT;
      isShowcode.value = false;
      timer.value = setInterval(() => {
        if (count.value > 0 && count.value <= TIME_COUNT) {
          count.value--;
        } else {
          isShowcode.value = true;
          clearInterval(timer.value);
          timer.value = 0;
        }
      }, 1000);
    }
    // 获取验证码
    httpcode.sendCaptcha({ mobile: personalList.value[3].model, type: 0 });
  }
};
//个人认证的信息
const personalList = ref([
  {
    name: '姓名 :',
    placeholder: '请输入联系人',
    model: '',
    length: 500,
    id: 0,
  },
  {
    name: '身份证号 :',
    placeholder: '请输入身份证号',
    model: '',
    length: 18,
    id: 1,
  },
  {
    name: '常住地址 :',
    placeholder: '请输入常住地址',
    model: '',
    length: 500,
    id: 2,
  },
  {
    name: '手机号码 :',
    placeholder: '请输入手机号码',
    model: '',
    length: 11,
    id: 3,
  },
]);
//判断是否认证并获取信息
const get_register_info = () => {
  const data = {
    token: token,
  };
  http.get_register_info({ params: data }).then((res) => {
    if (res.data.code == 200) {
      VerificList.value[4].model = res.data.data.mobile;
      personalList.value[3].model = res.data.data.mobile;
    }
  });
};
get_register_info();
//用户获取认证资料
const certification_status = ref<boolean>(false);
const certificationStatus = ref<number>();
const certificationType = ref<number>();
const rejectreason = ref<string>();
const enclosure = ref<string>();
const userGetInfo = () => {
  const data = {
    token: token,
    time: new Date().getTime(),
  };
  http.user_get_authentication_info({ params: data }).then((res) => {
    Privacychecked.value = true;
    res.data.data == null ? (authenStatus.value = false) : (authenStatus.value = true);
    res.data.data.status != 2 ? (certification_status.value = true) : (certification_status.value = false);
    modeList.value.splice(1);
    certificationStatus.value = res.data.data.status;
    certificationType.value = res.data.data.certification_type;
    rejectreason.value = res.data.data.reject_reason;
    enclosure.value = res.data.data.enclosure;
    if (certificationType.value == 2) {
      modeList.value[0].checked = true;
      secondCity.value = res.data.data.industry;
      VerificList.value[0].model = res.data.data.name;
      VerificList.value[1].model = res.data.data.id_number;
      VerificList.value[2].model = res.data.data.address;
      VerificList.value[3].model = res.data.data.contact_person;
      VerificList.value[4].model = res.data.data.mobile;
      secondCity.value = res.data.data.industry;
      imageUrlel.value = res.data.data.certificate_front;
      pcImgname.value = res.data.data.certificate_front.split('imgsrc=')[1];
    }
    // if (certificationType.value == 1) {
    //   modeList.value[0].checked = false;
    //   modeList.value[1].checked = true;
    //   personalList.value[0].model = res.data.data.name;
    //   personalList.value[1].model = res.data.data.id_number;
    //   personalList.value[3].model = res.data.data.mobile;
    //   personalList.value[2].model = res.data.data.address;
    //   secondCity.value = res.data.data.industry;
    //   identityUpImg.value = res.data.data.certificate_front;
    //   identitydownImg.value = res.data.data.certificate_rear;
    // }
  });
};
userGetInfo();
//上传图片
const imageUrlel = ref<string>(''); //企业营业执照
const pcImgname = ref<string>(); //企业营业执照名字
const identityUpImg = ref<string>(''); //身份证正面图片
const IDcardupname = ref<string>(); //身份证正面图片名字
const identitydownImg = ref<string>(''); //身份证反面图片
const IDcarddownname = ref<string>(); //身份证反面图片名字
//活动海报的数组
const fileList = ref([]);
const loading = reactive({
  enterpriseImg: false, //营业执照
  identityUp: false, //身份证正面
  identitydown: false, //身份证反面
});
//删除图片
const clearImg = (keyword: string) => {
  switch (keyword) {
    case 'enterpriseImg':
      pcImgname.value = '';
      imageUrlel.value = '';
      break;
    case 'identityUp':
      IDcardupname.value = '';
      identityUpImg.value = '';
      break;
    case 'identitydown':
      identitydownImg.value = '';
      IDcarddownname.value = '';
      break;
  }
};
const handleChange = (info: FileInfo, keyword: string) => {
  if (info.file.status === 'uploading') {
    loading[keyword] = true;
    return;
  }
  if (info.file.status === 'done') {
    // getBase64(info.file.originFileObj, () => {
    if (info.file?.response?.code === 200) {
      switch (keyword) {
        case 'enterpriseImg':
          imageUrlel.value = info.file?.response?.data.url;
          pcImgname.value = info.file?.response?.data.url.split('imgsrc=')[1];
          break;
        case 'identityUp':
          identityUpImg.value = info.file?.response?.data.url;
          IDcardupname.value = info.file?.response?.data.url.split('imgsrc=')[1];
          // personalList.value[2].model = JSON.parse(info.file?.response?.data.body).address;
          personalList.value[0].model = JSON.parse(info.file?.response?.data.body).name;
          personalList.value[1].model = JSON.parse(info.file?.response?.data.body).num;
          break;
        case 'identitydown':
          identitydownImg.value = info.file?.response?.data.url;
          IDcarddownname.value = info.file?.response?.data.url.split('imgsrc=')[1];
          break;
      }
    } else {
      message.error(info.file?.response?.error);
    }
    loading[keyword] = false;
    // });
  }
  if (info.file.status === 'error') {
    loading[keyword] = false;
    message.error('上传失败');
  }
};
//企业认证的保存
const companyClick = () => {
  if (VerificList.value[0].model == '') {
    message.info('企业名称不能为空');
    return;
  }
  if (VerificList.value[1].model == '') {
    message.info('统一信用代码不能为空');
    return;
  }
  // if (!/^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/.test(VerificList.value[1].model)) {
  //   message.info('请填写正确的信用代码');
  //   return;
  // }
  if (VerificList.value[2].model == '') {
    message.info('经营地址不能为空');
    return;
  }
  if (VerificList.value[3].model == '') {
    message.info('联系人不能为空');
    return;
  }
  if (VerificList.value[4].model == '') {
    message.info('手机号码不能为空');
    return;
  }
  if (!/^[1][3-9]\d{9}$/.test(VerificList.value[4].model)) {
    message.info('请填写正确的手机号');
    return;
  }
  if (Privacychecked.value == false) {
    message.info('请勾选隐私协议');
    return;
  }
  //保存数据
  const data = {
    token: token,
    certification_type: modeId.value,
    name: VerificList.value[0].model,
    id_number: VerificList.value[1].model,
    address: VerificList.value[2].model,
    contact_person: VerificList.value[3].model,
    mobile: VerificList.value[4].model,
    industry: secondCity.value,
    certificate_front: pcImgname.value,
    certificate_rear: '',
    code: mobilecode.value,
  };
  http
    .user_authentication(data)
    .then((res) => {
      authenStatus.value = true;
      isShowcode.value = true;
      showCodeBtntwo.value = false;
      userGetInfo();
      message.success(res.data.message);
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
//个人认证的保存
const personalClick = () => {
  if (personalList.value[0].model == '') {
    message.info('姓名不能为空');
    return;
  }
  if (personalList.value[1].model == '') {
    message.info('身份证不能为空');
    return;
  }
  if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(personalList.value[1].model)) {
    message.info('请输入正确的身份证号');
    return;
  }
  if (personalList.value[2].model == '') {
    message.info('常住地址不能为空');
    return;
  }
  if (personalList.value[3].model == '') {
    message.info('手机号码不能为空');
    return;
  }
  if (!/^[1][3-9]\d{9}$/.test(personalList.value[3].model)) {
    message.info('请填写正确的手机号');
    return;
  }
  if (Privacychecked.value == false) {
    message.info('请勾选隐私协议');
    return;
  }
  //保存数据
  const data = {
    token: token,
    certification_type: modeId.value, //认证类型
    name: personalList.value[0].model, //姓名
    id_number: personalList.value[1].model, //身份证
    mobile: personalList.value[3].model, //手机号
    address: personalList.value[2].model, //常住地址
    industry: secondCity.value,
    certificate_front: IDcardupname.value, //身份证正面图
    certificate_rear: IDcarddownname.value, //身份证面图id
    contact_person: '', //认证联系人
    code: mobilecode.value,
  };
  http
    .user_authentication(data)
    .then((res) => {
      authenStatus.value = true;
      showCodeBtn.value = false;
      isShowcode.value = true;
      userGetInfo();
      message.success(res.data.message);
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
//修改认证
const authentiClick = () => {
  authenStatus.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (authenStatus.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (certificationStatus.value == 3)
              ? (_openBlock(), _createBlock(_component_svg_icon, {
                  key: 0,
                  class: "svgName",
                  "icon-class": "reject"
                }))
              : (_openBlock(), _createBlock(_component_svg_icon, {
                  key: 1,
                  class: "svgName",
                  "icon-class": "authentication"
                }))
          ]),
          (certificationStatus.value != 3)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(certificationType.value == 2 ? '认证成功!' : '认证成功!'), 1))
            : _createCommentVNode("", true),
          (certificationStatus.value == 3)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(certificationType.value == 1 ? '认证已被驳回' : '将在1-3个工作日内完成审核'), 1))
            : _createCommentVNode("", true),
          (certificationType.value == 2 && certificationStatus.value == 3)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "认证被驳回!"))
            : _createCommentVNode("", true),
          (certificationType.value == 2 && certificationStatus.value == 3)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createTextVNode(_toDisplayString(rejectreason.value) + " ", 1),
                _createElementVNode("a", {
                  href: enclosure.value,
                  style: {"color":"#00ccb0"}
                }, "立即查看", 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", null, [
            _createVNode(_unref(ExclamationCircleFilled), { class: "infoIcon" })
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("span", null, "根据相关法规要求，直播间认证需要本人年满18周岁，并亲自 实名认证，该认证将履行严格保密义务，请放心上传。", -1))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[11] || (_cache[11] = _createElementVNode("span", null, "请选择认证类型", -1)),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modeList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["Switch_mode_type", item.id == modeId.value ? 'Switch_mode_types' : '']),
                key: item.id,
                onClick: _withModifiers(($event: any) => (getMode(item.id)), ["stop"])
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_svg_icon, {
                      class: "svgName",
                      "icon-class": item.icon
                    }, null, 8, ["icon-class"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_a_radio, {
                      checked: item.checked,
                      "onUpdate:checked": ($event: any) => ((item.checked) = $event)
                    }, null, 8, ["checked", "onUpdate:checked"])
                  ])
                ])
              ], 10, _hoisted_13))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          (modeId.value == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(Ccertificates, {
                      "file-list": fileList.value,
                      type: 0,
                      disabled: false,
                      "handle-change": (info) => handleChange(info, 'enterpriseImg'),
                      loading: loading.enterpriseImg,
                      "image-name": imageUrlel.value,
                      "click-stop": (info) => clearImg('enterpriseImg'),
                      plus: false,
                      data: () => ({ type: 2, side: 'face' }),
                      class: "upload"
                    }, {
                      uploadImg: _withCtx(() => [
                        _createVNode(_component_svg_icon, {
                          "icon-class": "Complayupload",
                          "font-size": "60px"
                        }),
                        _cache[12] || (_cache[12] = _createElementVNode("p", null, "点击上传营业执照", -1))
                      ]),
                      _: 1
                    }, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(VerificList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "info_item",
                      key: index
                    }, [
                      _createElementVNode("span", _hoisted_24, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", { style: {"color":"red"} }, "*", -1)),
                        _createTextVNode(" " + _toDisplayString(item.name), 1)
                      ]),
                      _createVNode(_component_a_input, {
                        class: "establish_top_input",
                        size: "small",
                        autosize: true,
                        placeholder: item.placeholder,
                        value: item.model,
                        "onUpdate:value": ($event: any) => ((item.model) = $event),
                        maxlength: item.length,
                        onChange: ($event: any) => (changeMobile(item.id == 4))
                      }, null, 8, ["placeholder", "value", "onUpdate:value", "maxlength", "onChange"])
                    ]))
                  }), 128)),
                  (showCodeBtntwo.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", null, [
                          _createElementVNode("span", { style: {"color":"red"} }, "*"),
                          _createTextVNode(" 验证码 :")
                        ], -1)),
                        _createElementVNode("span", null, [
                          _createVNode(_component_a_input, {
                            value: mobilecode.value,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((mobilecode).value = $event)),
                            placeholder: "请输入验证码",
                            maxlength: 4
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("span", null, [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (getCode(modeId.value))),
                            disabled: !_unref(isShowcode)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(isShowcode) ? '获取验证码' : _unref(count)), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "selectitem" }, [
                      _createElementVNode("span", { style: {"color":"red"} }, "*"),
                      _createTextVNode(" 所在行业 :")
                    ], -1)),
                    _createVNode(_unref(aSpace), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(aSelect), {
                          value: province.value,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((province).value = $event)),
                          options: _unref(provinceData).map((pro) => ({ lable: pro, value: pro })),
                          bordered: false,
                          onChange: selectChange
                        }, null, 8, ["value", "options"]),
                        _createVNode(_unref(aSelect), {
                          value: secondCity.value,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((secondCity).value = $event)),
                          options: cities.value.map((city) => ({ value: city })),
                          bordered: false,
                          onChange: selectChangeTwo
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_a_checkbox, {
                        checked: Privacychecked.value,
                        "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((Privacychecked).value = $event))
                      }, null, 8, ["checked"]),
                      _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"agree\" data-v-35535cb2> 已经阅读并同意 <a href=\"https://www.qing.tv/law/statement\" target=\"blank\" data-v-35535cb2>法律声明</a>、 <a href=\"https://www.qing.tv/law/privacy\" target=\"blank\" data-v-35535cb2>隐私政策</a>、 <a href=\"https://www.qing.tv/law/service-agreement\" target=\"blank\" data-v-35535cb2>直播服务协议</a>、 <a href=\"https://www.qing.tv/law/media-storage\" target=\"blank\" data-v-35535cb2>媒体存储服务协议</a>。 </div>", 1))
                    ]),
                    _createElementVNode("div", {
                      class: "buttonBox",
                      onClick: companyClick
                    }, [
                      _createVNode(_component_a_button, { type: "primary" }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("提交认证", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("div", { style: {"width":"100%","height":"10px"} }, null, -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (modeId.value == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(Ccertificates, {
                      "file-list": fileList.value,
                      type: 1,
                      disabled: false,
                      "handle-change": (info) => handleChange(info, 'identityUp'),
                      loading: loading.identityUp,
                      "image-name": identityUpImg.value,
                      "click-stop": (info) => clearImg('identityUp'),
                      data: () => ({ type: 1, side: 'face' }),
                      class: "upload",
                      plus: false
                    }, {
                      uploadImg: _withCtx(() => [
                        _createVNode(_component_svg_icon, {
                          "icon-class": "idDown",
                          "font-size": "60px"
                        }),
                        _cache[19] || (_cache[19] = _createElementVNode("p", null, "点击上传身份证正面", -1))
                      ]),
                      _: 1
                    }, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"]),
                    _createVNode(Ccertificates, {
                      "file-list": fileList.value,
                      type: 2,
                      disabled: false,
                      "handle-change": (info) => handleChange(info, 'identitydown'),
                      loading: loading.identitydown,
                      "image-name": identitydownImg.value,
                      "click-stop": (info) => clearImg('identitydown'),
                      plus: false,
                      data: () => ({ type: 1, side: 'back' }),
                      class: "upload"
                    }, {
                      uploadImg: _withCtx(() => [
                        _createVNode(_component_svg_icon, {
                          "icon-class": "idUp",
                          "font-size": "60px"
                        }),
                        _cache[20] || (_cache[20] = _createElementVNode("p", null, "点击上传身份证反面", -1))
                      ]),
                      _: 1
                    }, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(personalList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "info_item",
                      key: index
                    }, [
                      _createElementVNode("span", _hoisted_33, [
                        _cache[21] || (_cache[21] = _createElementVNode("span", { style: {"color":"red"} }, "*", -1)),
                        _createTextVNode(" " + _toDisplayString(item.name), 1)
                      ]),
                      _createVNode(_component_a_input, {
                        class: "establish_top_input",
                        size: "small",
                        autosize: true,
                        placeholder: item.placeholder,
                        value: item.model,
                        "onUpdate:value": ($event: any) => ((item.model) = $event),
                        maxlength: item.length,
                        onChange: ($event: any) => (changeMobileTwo(item.id == 3))
                      }, null, 8, ["placeholder", "value", "onUpdate:value", "maxlength", "onChange"])
                    ]))
                  }), 128)),
                  (showCodeBtn.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _cache[22] || (_cache[22] = _createElementVNode("span", null, [
                          _createElementVNode("span", { style: {"color":"red"} }, "*"),
                          _createTextVNode(" 验证码 :")
                        ], -1)),
                        _createElementVNode("span", null, [
                          _createVNode(_component_a_input, {
                            value: mobilecode.value,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((mobilecode).value = $event)),
                            placeholder: "请输入验证码",
                            maxlength: 4
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("span", null, [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (getCode(modeId.value))),
                            disabled: !_unref(isShowcode)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(isShowcode) ? '获取验证码' : _unref(count)), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_35, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "selectitem" }, [
                      _createElementVNode("span", { style: {"color":"red"} }, "*"),
                      _createTextVNode(" 所在行业 :")
                    ], -1)),
                    _createVNode(_unref(aSpace), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(aSelect), {
                          value: province.value,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((province).value = $event)),
                          options: _unref(provinceData).map((pro) => ({ lable: pro, value: pro })),
                          bordered: false,
                          onChange: selectChange
                        }, null, 8, ["value", "options"]),
                        _createVNode(_unref(aSelect), {
                          value: secondCity.value,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((secondCity).value = $event)),
                          options: cities.value.map((city) => ({ value: city })),
                          bordered: false,
                          onChange: selectChangeOne
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_a_checkbox, {
                        checked: Privacychecked.value,
                        "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((Privacychecked).value = $event))
                      }, null, 8, ["checked"]),
                      _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"agree\" data-v-35535cb2> 已经阅读并同意 <a href=\"https://www.qing.tv/law/statement\" target=\"blank\" data-v-35535cb2>法律声明</a>、 <a href=\"https://www.qing.tv/law/privacy\" target=\"blank\" data-v-35535cb2>隐私政策</a>、 <a href=\"https://www.qing.tv/law/service-agreement\" target=\"blank\" data-v-35535cb2>直播服务协议</a>、 <a href=\"https://www.qing.tv/law/media-storage\" target=\"blank\" data-v-35535cb2>媒体存储服务协议</a>。 </div>", 1))
                    ]),
                    _createElementVNode("div", {
                      class: "buttonBox",
                      onClick: personalClick
                    }, [
                      _createVNode(_component_a_button, { type: "primary" }, {
                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                          _createTextVNode("提交认证", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("div", { style: {"width":"100%","height":"10px"} }, null, -1))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
}
}

})